import ListSearchBar from "../components/ListSearchBar";
/* eslint-disable jsx-a11y/anchor-is-valid */

import { Button, Dropdown, Form, Nav, Table } from "react-bootstrap";
import { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import { useTranslate } from "../hooks/LanguageProvider";
import { NavLink } from "react-router-dom";
import { PagePermission } from "../utilities/permissions";
import PropagateLoader from "react-spinners/PropagateLoader";
import { toast } from "react-toastify";
import { usePagePreferences } from "../hooks/usePagePreferences";
const backendUrl = process.env.REACT_APP_BACKEND_URL;

interface UserInterface {
  id_user: number;
  nom_user: string;
  prenom_user: string;
}

interface Device {
  id_dispositif: number;
  psn_dispositif: string | null;
  nom_groupe: string | null;
  usergps: string | null;
  type_dispositif: string | null;
  model_dispositif: string | null;
  numero_puce: string | null;
  serial_number: string | null;
  operateur_puce: string | null;
  id_user: number;
}

export function Devices() {
  const page_permission_id = 6;

  const { translate } = useTranslate();
  const [listDevice, setDevices] = useState<Device[]>([]);
  const [pageCount, setPageCount] = useState(0);
  let [total, setTotal] = useState(0);
  const [Users, setUsers] = useState<UserInterface[]>([]);
  const user_id = localStorage.getItem("userid");
  const {
    preferences: listPreferences,
    setPreference: setListPreference,
    setPreferences: setListPreferences,
    loaded: listPreferencesLoaded,
  } = usePagePreferences("devices", {
    limitValue: 10,
    currentPage: 1,
    type: 6,
    typeSearch: "Phone number",
    column: "PSN",
    sort: "ASC",
    search: "",
  });
  let [limitValue, setSelectedLimitValue] = useState(Number(listPreferences.limitValue) || 10);
  const [loading, setLoading] = useState(true);

  const [selectedSearch, setSelectedSearch] = useState(translate("Phone number"));
  const [type, setType] = useState(Number(listPreferences.type ?? 6));
  const [typeSearch, setTypeSearch] = useState(String(listPreferences.typeSearch || "Phone number"));
  const [column, setSortColumn] = useState(String(listPreferences.column || "PSN"));
  const [sort, setSort] = useState(String(listPreferences.sort || "ASC"));
  const [search, setSearch] = useState(String(listPreferences.search || ""));
  const [currentPage, setCurrentPage] = useState<number>(Number(listPreferences.currentPage) || 1);


  const [selectedDevices, setSelectedDevices] = useState<string[]>([]);
  const [selectAll, setSelectAll] = useState(false);


  type ColumnKey =
    | "id_dispositif"
    | "psn_dispositif"
    | "nom_groupe"
    | "usergps"
    | "id_user"
    | "type_dispositif"
    | "model_dispositif"
    | "numero_puce"
    | "serial_number"
    | "operateur_puce"
    ;

  interface SelectedColumns {
    id_dispositif: boolean;
    psn_dispositif: boolean;
    nom_groupe: boolean;
    usergps: boolean;
    type_dispositif: boolean;
    model_dispositif: boolean;
    numero_puce: boolean;
    serial_number: boolean;
    operateur_puce: boolean;
  }

  const columns = [
    { key: "id_dispositif", label: "ID device" },
    { key: "psn_dispositif", label: "PSN" },
    { key: "nom_groupe", label: "Groupe" },
    { key: "usergps", label: "User GPS" },
    { key: "type_dispositif", label: "Type device" },
    { key: "model_dispositif", label: "Device model" },
    { key: "numero_puce", label: "Phone number" },
    { key: "serial_number", label: "Serial number" },
    { key: "operateur_puce", label: "SIM operator" },
  ];

  const [selectedColumns, setSelectedColumns] = useState<SelectedColumns>({
    id_dispositif: true,
    psn_dispositif: true,
    nom_groupe: true,
    usergps: true,
    type_dispositif: true,
    model_dispositif: true,
    numero_puce: true,
    serial_number: true,
    operateur_puce: true,
  });
  const handleColumnChange = (column: string) => {
    setSelectedColumns((prevState: any) => ({
      ...prevState,
      [column]: !prevState[column],
    }));
  };

  const handleTypeSearch = (event: any) => {
    const selectedValue = event.target.textContent;
    console.log(selectedValue);
    let nextType = type;
    switch (selectedValue) {
      case translate("ID device"):
        setSelectedSearch(translate("ID device"));
        nextType = 0;
        setType(nextType);
        break;
      case translate("PSN"):
        setSelectedSearch(translate("PSN"));
        nextType = 1;
        setType(nextType);
        break;
      case translate("Group"):
        setSelectedSearch(translate("Group"));
        nextType = 2;
        setType(nextType);
        break;
      case translate("User GPS"):
        setSelectedSearch(translate("User GPS"));
        nextType = 3;
        setType(nextType);
        break;
      case translate("Device type"):
        setSelectedSearch(translate("IButton"));
        nextType = 4;
        setType(nextType);
        break;
      case translate("Device model"):
        setSelectedSearch(translate("Model device"));
        nextType = 5;
        setType(nextType);
        break;
      case translate("Phone number"):
        setSelectedSearch(translate("Phone number"));
        nextType = 6;
        setType(nextType);
        break;
      case translate("Serial number"):
        setSelectedSearch(translate("Serial number"));
        nextType = 7;
        setType(nextType);
        break;
      case translate("Type SIM"):
        setSelectedSearch(translate("Operateur puce"));
        nextType = 8;
        setType(nextType);
        break;
      case translate("N° SIM"):
        setSelectedSearch(translate("Phone number"));
        nextType = 6;
        setType(nextType);
        break;
      default:
        console.log("Unknown selection");
        break;
    }

    setTypeSearch(translate(selectedValue));
    setCurrentPage(1);
    setListPreferences({ type: nextType, typeSearch: selectedValue, currentPage: 1 });
    console.log("Selected value:", selectedValue);
  };

  const Options = [
    "ID device",
    "PSN",
    "Group",
    "User GPS",
    "Device type",
    "Device model",
    "Phone number",
    "Serial number",
    "Type SIM",
  ];

  const findUserById = (
    id: number
  ): { nom_user: string; prenom_user: null | string } | undefined => {
    const foundUser = Users.find((user) => user.id_user === id);

    if (foundUser) {
      const { nom_user, prenom_user } = foundUser;
      return { nom_user, prenom_user };
    }

    return undefined;
  };




  const searchColumn: { [key: string]: number } = {
    id_dispositif: 0,
    psn_dispositif: 1,
    nom_groupe: 2,
    usergps: 3,
    type_dispositif: 4,
    model_dispositif: 5,
    numero_puce: 6,
    serial_number: 7,
    operateur_puce: 8,
    id_user: 9,
  };


  const handleSelectChange = async (event: any) => {
    const newValue = event.target.value;
    const nextLimit = parseInt(newValue, 10);
    setCurrentPage(1);
    setSelectedLimitValue(nextLimit);
    setListPreferences({ limitValue: nextLimit, currentPage: 1 });
    const commentsFormServer = await getDevices(
      nextLimit,
      1,
      search,
      type,
      column,
      sort
    );
    setDevices(commentsFormServer);
    window.scrollTo(0, 0);
  };

  const getDevices = async (
    limitValue: number,
    currentPage: number,
    search: string,
    type: number,
    column: string,
    sort: string
  ) => {
    const bodyData = JSON.stringify({
      limitValue: limitValue,
      currentPage: currentPage,
      search: search,
      type: type,
      id_user: user_id,
      column: searchColumn[column],
      sort: sort,
    });

    try {
      setLoading(true);

      const total_pages = await fetch(
        `${backendUrl}/api/device/search/totalpage`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: bodyData,
          mode: "cors",
        }
      );

      const totalPages = await total_pages.json();
      total = totalPages[0]["total"];
      setTotal(totalPages[0]["total"]);

      const deviceResponse = await fetch(`${backendUrl}/api/device/search`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: bodyData,
        mode: "cors",
      });

      if (!deviceResponse.ok) {
        console.error("Error retrieving vehicles list");
        setLoading(false);
        return;
      }

      const data = await deviceResponse.json();
      setPageCount(Math.ceil(total / limitValue));
      setDevices(data);
      return data;
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!listPreferencesLoaded) return;
    const nextLimit = Number(listPreferences.limitValue) || 10;
    const nextPage = Number(listPreferences.currentPage) || 1;
    const nextSearch = String(listPreferences.search || "");
    const nextType = Number(listPreferences.type ?? 6);
    const nextTypeSearch = String(listPreferences.typeSearch || "Phone number");
    const nextColumn = String(listPreferences.column || "PSN");
    const nextSort = String(listPreferences.sort || "ASC");

    setSelectedLimitValue(nextLimit);
    setCurrentPage(nextPage);
    setSearch(nextSearch);
    setType(nextType);
    setTypeSearch(nextTypeSearch);
    setSortColumn(nextColumn);
    setSort(nextSort);
    getUser(user_id);
    getDevices(nextLimit, nextPage, nextSearch, nextType, nextColumn, nextSort);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user_id, listPreferencesLoaded, listPreferences]);

  const fetchDevice = async (currentPage: any, limitValue: any) => {
    const res = await fetch(
      `${backendUrl}/api/device/${currentPage}/${limitValue}/${user_id}`,
      { mode: "cors" }
    );
    const data = await res.json();
    return data;
  };

  async function getUserPermissions(user_id: any) {
    try {
      const response = await fetch(
        `${backendUrl}/api/permission/find/${user_id}/${page_permission_id}`,
        { mode: "cors" }
      );
      const data = await response.json();

      return data;
    } catch (error) {
      console.error("Error fetching user permissions:", error);
      throw error;
    }
  }

  const getUser = async (user_id: any) => {
    try {
      const res = await fetch(`${backendUrl}/api/users/find/${user_id}`, {
        mode: "cors",
      });

      if (!res.ok) {
        console.error("Error retrieving users");
        return;
      }
      setUsers(await res.json());
    } catch (error) {
      console.error("Error retrieving users", error);
    }
  };

  const handleSortingColum = (currentColumn: string) => {
    const nextSort = sort === "DESC" ? "ASC" : "DESC";
    setSort(nextSort);
    setSortColumn(currentColumn);
    setCurrentPage(1);
    setListPreferences({ sort: nextSort, column: currentColumn, currentPage: 1 });
    getDevices(limitValue, 1, search, type, currentColumn, nextSort);
  };

  const handlePageClick = async (data: any) => {
    let currentPage = data.selected + 1;
    await getDevices(
      limitValue,
      parseInt(currentPage),
      search,
      type,
      column,
      sort
    );
    setCurrentPage(currentPage);
    setListPreference("currentPage", currentPage);
    window.scrollTo(0, 0);
  };

  const handleAdvancedSearch = (event: any) => {
    const newValue = event.target.value;
    setSearch(newValue);
    setCurrentPage(1);
    setListPreferences({search: newValue, currentPage: 1});
  };
  const handleResetSearch = () => {
    setSearch("");
    setCurrentPage(1);
    setListPreferences({search: "", currentPage: 1});
  };

  const [isDevicesSelected, setIsDevicesSelected] = useState(false);

  const handleDevicesSelect = (DeviceID: string) => {
    let updatedSelectedDevices: string[] = [];

    // If "Select All Vehicles" is enabled, selects or deselects all vehicles
    if (selectAll) {
      updatedSelectedDevices = selectedDevices.includes(DeviceID)
        ? selectedDevices.filter((id) => id !== DeviceID) //Deselect if already selected
        : listDevice.map((device) => device.id_dispositif.toString()); // Select all vehicles
    } else {
      //Managing selection/normal selection of an individual vehicle
      if (selectedDevices.includes(DeviceID)) {
        updatedSelectedDevices = selectedDevices.filter(
          (id) => id !== DeviceID
        );
      } else {
        updatedSelectedDevices = [...selectedDevices, DeviceID];
      }
    }

    // Updates the list of selected vehicles
    setSelectedDevices(updatedSelectedDevices);

    // Updates the Vehicles Selected state (activate if at least one is selected)
    setIsDevicesSelected(updatedSelectedDevices.length > 0);

    console.log(updatedSelectedDevices);
  };


  // In the handleSelectAllDrivers function
  const handleSelectAllDevice = (checked: boolean) => {
    setSelectAll(checked);
    console.log(checked);
    if (checked) {
      const allVehicleIDs = listDevice.map((device) =>
        device.id_dispositif.toString()
      );
      setSelectedDevices(allVehicleIDs);
      setIsDevicesSelected(true); // Mark as selected
    } else {
      setSelectedDevices([]);
      setIsDevicesSelected(false); // Mark as unselected
    }
  };


  const updateDeviceList = async () => {
    // 1. Affichage du toast loading
    const toastId = toast.loading("Mise à jour en cours...", {
      position: "bottom-right",
    });

    try {
      // 2. Ajout d'un timeout pour éviter blocage infini
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 15000); // 15s timeout

      const res = await fetch(
        `${backendUrl}/api/device/updateDeviceList?apiKey=yF3qeznEn3kBbvM5eVQl`,
        { method: "GET", signal: controller.signal }
      );

      clearTimeout(timeoutId);

      // 3. Vérifier si la réponse est OK
      if (!res.ok) {
        throw new Error(`Erreur API : ${res.status}`);
      }

      const data = await res.json();

      // 4. Vérifier le message d'erreur éventuel
      if (data?.message?.toLowerCase().includes("error")) {
        toast.update(toastId, {
          render: "Erreur lors de la mise à jour",
          type: "error",
          isLoading: false,
          autoClose: 3000,
          position: "bottom-right",
        });
        return;
      }

      // 5. Récupérer les infos du résultat
      const updated = data?.result?.updated ?? 0;
      const inserted = data?.result?.inserted ?? 0;

      // 6. Afficher toast succès
      toast.update(toastId, {
        render: `Succès : ${updated} modifiés, ${inserted} ajoutés`,
        type: "success",
        isLoading: false,
        autoClose: 3000,
        position: "bottom-right",
      });

      // 7. Recharge la liste
      await getDevices(limitValue, currentPage, search, type, column, sort);

    } catch (err: any) {
      console.error(err);

      // 8. Toast erreur réseau / timeout
      toast.update(toastId, {
        render: err.name === "AbortError" ? "Timeout API" : "Erreur réseau",
        type: "error",
        isLoading: false,
        autoClose: 3000,
      });
    }
  };

  return (
    <>
      <div className="row">
        <h4 className="col-sm-6 col-md-6">
          <i
            className="las la-compass"
            data-rel="bootstrap-tooltip"
            title="Devices"
          ></i>
          {translate("Devices")} ({total})
        </h4>
        <div className="col-sm-6 col-md-6 ">
          <div
            id="DataTables_Table_0_filter"
            className="float-right dataTables_filter mr-3"
          >

            {Number(user_id) === 1 && (
              <Button
                id="update-devices-btn"
                className="btn btn-danger mr-1"
                variant="danger"
                onClick={updateDeviceList}
                disabled={loading}
              >
                <i
                  className={`la la-sync ${loading ? "la-spin" : ""}`}
                  style={{ fontSize: "16px" }}
                ></i>
                {loading ? "Updating..." : "Update Devices"}
              </Button>
            )}


            <NavLink to="/Device/add" className="btn btn-primary  mr-1">
              <i className="las la-plus mr-3"></i>
              {translate("New devices")}
            </NavLink>

            {/* <a href="#" className="btn btn-outline-secondary  mr-1">
              <i className="las la-plus mr-3"></i>
              {translate("Import")}
            </a> */}

            <a href="#" className="btn btn-outline-info ">
              <i className="las la-file-excel mr-3"></i>
              {translate("Import")}
            </a>
          </div>
        </div>
      </div>
      <div>
        <div className="row">
          <div
            className="col-md-4 list-search-column"
            style={{ margin: "0px 0px 10px 0px", padding: "10px" }}
          >
            <ListSearchBar criteria={<Dropdown>
                <Dropdown.Toggle
                  variant="link"
                  id="dropdown-custom"
                  className="custom-toggle"
                >{translate(typeSearch)}</Dropdown.Toggle>
                <Dropdown.Menu onClick={handleTypeSearch}>
                  {Options.map((option) => (
                    <Dropdown.Item
                      key={option}
                      className={`${selectedSearch == translate(option) ? "active" : ""
                        }`}
                      onClick={() => setSelectedSearch(translate(option))}
                    >
                      {translate(option)}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>} onReset={handleResetSearch} resetLabel={translate("Reset search")}>
<input
                type="text"
                placeholder={`${translate("Search by")} ${translate(typeSearch)}`}
                value={search}
                onChange={handleAdvancedSearch}
                className="form-control"
              />
</ListSearchBar>
          </div>
          <div className="col-md-8 d-flex justify-content-end align-items-center">
            <div className="dataTables_length" id="DataTables_Table_0_length">
              <label style={{ marginBottom: "0" }}>
                {translate("Show")}
                <select
                  name="DataTables_Table_0_length"
                  aria-controls="DataTables_Table_0"
                  className="custom-select custom-select-sm form-control form-control-sm ml-2"
                  style={{ width: "66px" }}
                  value={limitValue}
                  onChange={handleSelectChange}
                >
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                  <option value="200">200</option>
                  <option value="500">500</option>
                </select>
              </label>
            </div>
            <Dropdown>
              <Dropdown.Toggle
                variant=""
                id="dropdown-basic"
                title={translate("Display columns")}
              >
                <i className="las la-eye"></i>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item
                  as="button"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={selectedColumns.id_dispositif}
                    onChange={() => handleColumnChange("id_dispositif")}
                  />
                  <span style={{ marginLeft: "10px" }}>{translate("ID")}</span>
                </Dropdown.Item>
                <Dropdown.Item
                  as="button"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={selectedColumns.psn_dispositif}
                    onChange={() => handleColumnChange("psn_dispositif")}
                  />
                  <span style={{ marginLeft: "10px" }}>{translate("PSN")}</span>
                </Dropdown.Item>
                <Dropdown.Item
                  as="button"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={selectedColumns.nom_groupe}
                    onChange={() => handleColumnChange("nom_groupe")}
                  />
                  <span style={{ marginLeft: "10px" }}>
                    {translate("Group")}
                  </span>
                </Dropdown.Item>
                <Dropdown.Item
                  as="button"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={selectedColumns.usergps}
                    onChange={() => handleColumnChange("usergps")}
                  />
                  <span style={{ marginLeft: "10px" }}>
                    {translate("User GPS")}
                  </span>
                </Dropdown.Item>
                <Dropdown.Item
                  as="button"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={selectedColumns.type_dispositif}
                    onChange={() => handleColumnChange("type_dispositif")}
                  />
                  <span style={{ marginLeft: "10px" }}>
                    {translate("Type Dispositif")}
                  </span>
                </Dropdown.Item>
                <Dropdown.Item
                  as="button"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={selectedColumns.model_dispositif}
                    onChange={() => handleColumnChange("model_dispositif")}
                  />
                  <span style={{ marginLeft: "10px" }}>
                    {translate("Modèle Dispositif")}
                  </span>
                </Dropdown.Item>
                <Dropdown.Item
                  as="button"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={selectedColumns.numero_puce}
                    onChange={() => handleColumnChange("numero_puce")}
                  />
                  <span style={{ marginLeft: "10px" }}>
                    {translate("Phone number")}
                  </span>
                </Dropdown.Item>
                <Dropdown.Item
                  as="button"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={selectedColumns.serial_number}
                    onChange={() => handleColumnChange("serial_number")}
                  />
                  <span style={{ marginLeft: "10px" }}>
                    {translate("Serial number")}
                  </span>
                </Dropdown.Item>
                <Dropdown.Item
                  as="button"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={selectedColumns.operateur_puce}
                    onChange={() => handleColumnChange("operateur_puce")}
                  />
                  <span style={{ marginLeft: "10px" }}>
                    {translate("Type SIM")}
                  </span>
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="table-responsive">
          <Table className="dataTable">
            <thead className="bg-white text-uppercase">
              <tr className="ligth ligth-data">
                <th>
                  <div className="checkbox d-inline-block">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={selectAll}
                      onChange={(e) =>
                        handleSelectAllDevice(e.target.checked)
                      }
                    />
                    <label className="form-check-label"></label>
                  </div>
                </th>

                {columns.map(
                  (column) =>
                    selectedColumns[column.key as keyof SelectedColumns] && (
                      <th
                        key={column.key}
                        className="sorting"
                        onClick={() => handleSortingColum(column.key)}
                      >
                        {translate(column.label)}
                      </th>
                    )
                )}
                <th>{translate("Actions")}</th>
              </tr>
            </thead>

            <tbody className="light-body">
              {loading ? (
                <tr style={{ textAlign: "center" }}>
                  <td className="text-center" colSpan={10}>
                    <p>
                      <PropagateLoader
                        color={"#123abc"}
                        loading={loading}
                        size={20}
                      />
                    </p>
                  </td>
                </tr>
              ) : listDevice.length > 0 ? (
                listDevice.map((device: Device) => {
                  const foundUser = findUserById(device.id_user);

                  return (
                    <tr
                      className={device.id_dispositif.toString()}
                    >
                      <td style={{ paddingBottom: "0px" }}>
                        <input
                          type="checkbox"
                          className="form-check"
                          id={`checkbox-${device.id_dispositif}`}
                          checked={selectedDevices.includes(
                            device.id_dispositif.toString()
                          )}
                          onChange={() =>
                            handleDevicesSelect(
                              device.id_dispositif.toString()
                            )
                          }
                        />
                        <label
                          htmlFor={`checkbox-${device.id_dispositif.toString()}`}
                          className="mb-0"
                        ></label>
                      </td>

                      {selectedColumns.id_dispositif && (<td>{device.id_dispositif}</td>)}
                      {selectedColumns.psn_dispositif && (<td>{device.psn_dispositif}</td>)}
                      {selectedColumns.nom_groupe && (<td>{device.nom_groupe || ""}</td>)}
                      {selectedColumns.usergps && (<td>{device.usergps}</td>)}
                      {selectedColumns.type_dispositif && (<td>{device.type_dispositif}</td>)}
                      {selectedColumns.model_dispositif && (<td>{device.model_dispositif}</td>)}
                      {selectedColumns.numero_puce && (<td>{device.numero_puce || ""}</td>)}
                      {selectedColumns.serial_number && (<td>{device.serial_number || ""}</td>)}
                      {selectedColumns.operateur_puce && (<td>{device.operateur_puce}</td>)}

                      <td>
                        <div className="d-flex align-items-center list-action">
                          <a
                            className="badge bg-warning mr-2"
                            data-toggle="tooltip"
                            data-placement="top"
                            title="Delete"
                          >
                            <i className="ri-pencil-line mr-0"></i>
                          </a>
                          <Nav.Link
                            to={`/Device/edit/${device.id_dispositif}`}
                            className="badge bg-success mr-2"
                            data-toggle="tooltip"
                            data-placement="top"
                            title="Edit"
                            as={NavLink}
                          >
                            <i className="ri-share-forward-fill mr-0"></i>
                          </Nav.Link>
                        </div>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr style={{ textAlign: "center" }}>
                  <td colSpan={11}>{translate("No device available")}</td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
        <div className="row">
          <div className="col-md-6 d-flex align-items-center">
            <span>
              {translate("Displaying")} {listDevice.length}{" "}
              {translate("out of")} {total}
            </span>
          </div>
          <div className="col-md-6">
            <ReactPaginate
              previousLabel={"previous"}
              nextLabel={"next"}
              breakLabel={"..."}
              pageCount={pageCount}
              forcePage={pageCount > 0 ? Math.min(currentPage - 1, pageCount - 1) : 0}
              marginPagesDisplayed={2}
              pageRangeDisplayed={3}
              onPageChange={handlePageClick}
              containerClassName={"pagination justify-content-center"}
              pageClassName={"page-item"}
              pageLinkClassName={"page-link"}
              previousClassName={"page-item"}
              previousLinkClassName={"page-link"}
              nextClassName={"page-item"}
              nextLinkClassName={"page-link"}
              breakClassName={"page-item"}
              breakLinkClassName={"page-link"}
              activeClassName={"active"}
            />
          </div>
        </div>
      </div>
    </>
  );
}
